import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, ButtonBase, Stack } from "@mui/material";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";

const SelectedVehicleSummary = ({ formObj, setDetailOpen, advertType }) => {
    return (
        <React.Fragment>
            <Box className="vehicle-info-container">
                <div className="vehicle-selected-absolute">
                    Selected
                </div>
                <div className="text-semibold font-size-18 pt-2">{formObj?.make || '-'} {formObj?.model || ''} {formObj?.manu_year ? (`(${formObj?.manu_year})`) : ''}</div>
                <Box sx={{ display: { lg: 'flex', md: 'flex' }, justifyContent: { lg: 'space-between', md: 'space-between' } }}>
                    <Stack sx={{ flexDirection: { lg: 'row', md: 'row', sm: 'column', xs: 'column' }, gap: 2, mt: 2 }}>
                        <div className="d-flex align-items-center">
                            <div className="subheader-2">Reg. No:</div>
                            <div className="mx-1">{formObj?.reg_no || '-'}</div>
                        </div>

                        <div className="d-flex align-items-center">
                            <div className="subheader-2">Year of Manufacture:</div>
                            <div className="mx-1">{formObj?.manu_year || '-'}</div>
                        </div>

                        <div className="d-flex align-items-center">
                            <div className="subheader-2">Engine Capacity:</div>
                            <div className="mx-1">{formObj?.engine_cap || '-'}cc</div>
                        </div>

                    </Stack>
                    {advertType !== 'used' && <div className="d-flex align-items-end">
                        <ButtonBase onClick={() => setDetailOpen(true)} style={{ borderRadius: 10, paddingInline: 5 }}>
                            <div className="d-flex align-items-center" style={{ color: '#B48A3C' }}>View details <Icon icon={'fluent:chevron-right-20-regular'} style={{ marginLeft: 5, height: 16 }} /></div>
                        </ButtonBase>
                    </div>}
                </Box>
            </Box>

        </React.Fragment>
    )
}

function mapStateToProps({ General, Layout }) {
    return {
    };
}


export default connect(mapStateToProps)(SelectedVehicleSummary);